import { alpha, darken, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const sharedButtonStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: darken(theme.palette.common.white, 0.1),
    boxShadow: 'none',
  },
});

export const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    marginRight: theme.spacing(1),
    flexShrink: 0,
    boxShadow: 'none',
  },
  button: sharedButtonStyles(theme),
  menuButton: {
    ...sharedButtonStyles(theme),
    minWidth: 0,
    padding: theme.spacing(0, 0.75),
    borderLeft: `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
  },
  buttonDisabled: {
    backgroundColor: `${alpha(theme.palette.common.white, 0.12)} !important`,
    color: `${alpha(theme.palette.common.white, 0.3)} !important`,
  },
}));
